import type { ValueOf } from '../util/typeUtils';

export const LOAN_REQUEST_APPLICANT_EDITING_COMMANDS = {
    addChild: 'addChild',
    addConsorsSchufaCreditToLead: 'addConsorsSchufaCreditToLead',
    addCredit: 'addCredit',
    addExpenseObligationToSupport: 'addExpenseObligationToSupport',
    addExpenseOther: 'addExpenseOther',
    addExpensePrivateHealthInsurance: 'addExpensePrivateHealthInsurance',
    addExpenseRental: 'addExpenseRental',
    addIncomeCapital: 'addIncomeCapital',
    addIncomeOther: 'addIncomeOther',
    addIncomePension: 'addIncomePension',
    addIncomeSecondaryEmployment: 'addIncomeSecondaryEmployment',
    addIncomeSpouse: 'addIncomeSpouse',
    addLiabilityBusinessCredit: 'addLiabilityBusinessCredit',
    addLiabilityCreditCard: 'addLiabilityCreditCard',
    addLiabilityInstallmentCredit: 'addLiabilityInstallmentCredit',
    addLiabilityLeasing: 'addLiabilityLeasing',
    addLiabilityOther: 'addLiabilityOther',
    addLiabilityOverdraft: 'addLiabilityOverdraft',
    addLiabilityOverdraftBusiness: 'addLiabilityOverdraftBusiness',
    addLiabilityRealEstateLoan: 'addLiabilityRealEstateLoan',
    addRealEstate: 'addRealEstate',
    changeApplicantAddress: 'changeApplicantAddress',
    changeApplicantEmail: 'changeApplicantEmail',
    changeApplicantEmployment: 'changeApplicantEmployment',
    changeApplicantLivingSituation: 'changeApplicantLivingSituation',
    changeApplicantMaritalStatus: 'changeApplicantMaritalStatus',
    changeApplicantName: 'changeApplicantName',
    changeApplicantPhone: 'changeApplicantPhone',
    changeApplicantPreviousAddress: 'changeApplicantPreviousAddress',
    changeBank: 'changeBank',
    changeCar: 'changeCar',
    changeChild: 'changeChild',
    changeExpenseObligationToSupport: 'changeExpenseObligationToSupport',
    changeExpenseOther: 'changeExpenseOther',
    changeExpensePrivateHealthInsurance: 'changeExpensePrivateHealthInsurance',
    changeExpenseRental: 'changeExpenseRental',
    changeIncomeCapital: 'changeIncomeCapital',
    changeIncomeOther: 'changeIncomeOther',
    changeIncomePension: 'changeIncomePension',
    changeIncomeSecondaryEmployment: 'changeIncomeSecondaryEmployment',
    changeIncomeSpouse: 'changeIncomeSpouse',
    changeLiabilityBusinessCredit: 'changeLiabilityBusinessCredit',
    changeLiabilityCreditCard: 'changeLiabilityCreditCard',
    changeLiabilityInstallmentCredit: 'changeLiabilityInstallmentCredit',
    changeLiabilityLeasing: 'changeLiabilityLeasing',
    changeLiabilityOther: 'changeLiabilityOther',
    changeLiabilityOverdraft: 'changeLiabilityOverdraft',
    changeLiabilityOverdraftBusiness: 'changeLiabilityOverdraftBusiness',
    changeLiabilityRealEstateLoan: 'changeLiabilityRealEstateLoan',
    changeRealEstate: 'changeRealEstate',
    changeRealEstateBuildingDescription: 'changeRealEstateBuildingDescription',
    removeChild: 'removeChild',
    removeCredit: 'removeCredit',
    removeExpenseObligationToSupport: 'removeExpenseObligationToSupport',
    removeExpenseOther: 'removeExpenseOther',
    removeExpensePrivateHealthInsurance: 'removeExpensePrivateHealthInsurance',
    removeExpenseRental: 'removeExpenseRental',
    removeIncomeCapital: 'removeIncomeCapital',
    removeIncomeOther: 'removeIncomeOther',
    removeIncomePension: 'removeIncomePension',
    removeIncomeSecondaryEmployment: 'removeIncomeSecondaryEmployment',
    removeIncomeSpouse: 'removeIncomeSpouse',
    removeLiabilityBusinessCredit: 'removeLiabilityBusinessCredit',
    removeLiabilityCreditCard: 'removeLiabilityCreditCard',
    removeLiabilityInstallmentCredit: 'removeLiabilityInstallmentCredit',
    removeLiabilityLeasing: 'removeLiabilityLeasing',
    removeLiabilityOther: 'removeLiabilityOther',
    removeLiabilityOverdraft: 'removeLiabilityOverdraft',
    removeLiabilityOverdraftBusiness: 'removeLiabilityOverdraftBusiness',
    removeLiabilityRealEstateLoan: 'removeLiabilityRealEstateLoan',
    removeRealEstate: 'removeRealEstate',
    requestApplicantCreditRating: 'requestApplicantCreditRating',
    updateApplicantBirthData: 'updateApplicantBirthData',
    updateApplicantResidenceData: 'updateApplicantResidenceData',
} as const;

export type LOAN_REQUEST_APPLICANT_EDITING_COMMAND = ValueOf<typeof LOAN_REQUEST_APPLICANT_EDITING_COMMANDS>;

export const LOAN_REQUEST_GENERAL_COMMANDS = {
    acceptOffer: 'acceptOffer',
    acknowledgeChange: 'acknowledgeChange',
    addAssignedAdvisor: 'addAssignedAdvisor',
    addConsorsNote: 'addConsorsNote',
    agreeApplicantAdvertisementConsent: 'agreeApplicantAdvertisementConsent',
    agreeApplicantDataProtection: 'agreeApplicantDataProtection',
    assignToUser: 'assignToUser',
    cancelConsorsSubscription: 'cancelConsorsSubscription',
    censorCoApplicant: 'censorCoApplicant',
    censorLoanrequest: 'censorLoanrequest',
    changeApplicantNoteFavorability: 'changeApplicantNoteFavorability',
    changeAssignedUser: 'changeAssignedUser',
    changeBucket: 'changeBucket',
    changeDocumentAcknowledgment: 'changeDocumentAcknowledgment',
    changeDocumentAttribution: 'changeDocumentAttribution',
    changeLegitimation: 'changeLegitimation',
    changeLiabilityHideState: 'changeLiabilityHideState',
    changeManualOffer: 'changeManualOffer',
    changeNoteContent: 'changeNoteContent',
    changeNoteFavorability: 'changeNoteFavorability',
    changeOfferCommission: 'changeOfferCommission',
    changeOfferFavorability: 'changeOfferFavorability',
    changeOfferSentAt: 'changeOfferSentAt',
    changeOfferStatus: 'changeOfferStatus',
    changeOfferTeaserState: 'changeOfferTeaserState',
    changeStatus: 'changeStatus',
    changeStatusToCancel: 'changeStatusToCancel',
    changeSystemNoteFavorability: 'changeSystemNoteFavorability',
    confirmPhoneLegitimation: 'confirmPhoneLegitimation',
    create: 'create',
    createApplicant: 'createApplicant',
    createApplicantNote: 'createApplicantNote',
    createNote: 'createNote',
    deleteApplicantNotes: 'deleteApplicantNotes',
    deleteManualOffer: 'deleteManualOffer',
    deleteResubmission: 'deleteResubmission',
    demandDocuments: 'demandDocuments',
    distributeLeads: 'distributeLeads',
    hideCoApplicant: 'hideCoApplicant',
    import: 'import',
    importEuropaceProcess: 'importEuropaceProcess',
    markNotificationProcessed: 'markNotificationProcessed',
    recordDocuments: 'recordDocuments',
    recordOffer: 'recordOffer',
    remindDemandedDocuments: 'remindDemandedDocuments',
    remove: 'remove',
    removeAssignedUser: 'removeAssignedUser',
    removeDocument: 'removeDocument',
    renameDocument: 'renameDocument',
    requestApplicantAdvertisementConsent: 'requestApplicantAdvertisementConsent',
    requestApplicantConsents: 'requestApplicantConsents',
    requestApplicantEmailVerification: 'requestApplicantEmailVerification',
    requestConsorsConsolidation: 'requestConsorsConsolidation',
    requestConsorsNotes: 'requestConsorsNotes',
    requestConsorsOffer: 'requestConsorsOffer',
    requestEuropaceOffers: 'requestEuropaceOffers',
    requestEuropaceOffersSynchronization: 'requestEuropaceOffersSynchronization',
    requestEuropaceProcessEvents: 'requestEuropaceProcessEvents',
    requestOfferDocumentsUpload: 'requestOfferDocumentsUpload',
    requestOffers: 'requestOffers',
    requestPc24CreditImport: 'requestPc24CreditImport',
    requestPc24LinkRegeneration: 'requestPc24LinkRegeneration',
    requestSkagCreditApplication: 'requestSkagCreditApplication',
    resetConsorsNotesFlag: 'resetConsorsNotesFlag',
    revealCoApplicant: 'revealCoApplicant',
    revokePhoneLegitimation: 'revokePhoneLegitimation',
    revokeResubmission: 'revokeResubmission',
    sendEmailMessage: 'sendEmailMessage',
    setActiveUser: 'setActiveUser',
    setResubmission: 'setResubmission',
    startIKProcess: 'startIKProcess',
    switchApplicants: 'switchApplicants',
    updateEuropaceProcess: 'updateEuropaceProcess',
    updateOfferRequestConditions: 'updateOfferRequestConditions',
    validateConsorsSubscription: 'validateConsorsSubscription',
    verifyApplicantEmail: 'verifyApplicantEmail',
    verifyCoApplicantEmail: 'verifyCoApplicantEmail',
} as const;

export type LOAN_REQUEST_GENERAL_COMMAND = ValueOf<typeof LOAN_REQUEST_GENERAL_COMMANDS>;

export const LOAN_REQUEST_COMMANDS = {
    ...LOAN_REQUEST_GENERAL_COMMANDS,
    ...LOAN_REQUEST_APPLICANT_EDITING_COMMANDS,
} as const;

export type LOAN_REQUEST_COMMAND = ValueOf<typeof LOAN_REQUEST_COMMANDS>;
